export default class NetworkError extends Error {
  constructor(){
    super('Unable to talk to server. Please check your internet connection and try again.')
  }
}
